import { apiGet, apiPost } from '@/features/shared/utils/dataFetching'
import {
  type FeesQueryKey,
  type NycOrdinanceFeeQueryKey,
} from '@/features/shop/services/Fees/queries'
import {
  type RetailerFeesResponse,
  type CartFeesResponse,
  type NycOrdinanceFeeResponse,
} from '@/features/shop/services/Fees/types'
import { type QueryFunctionContext } from '@tanstack/react-query'

export const fetchCartFee = (context: QueryFunctionContext<FeesQueryKey>) => {
  const [, storeParams] = context.queryKey
  return apiGet<CartFeesResponse>({
    config: { url: 'fees/v1/orders/fees' },
    options: { storeParams },
    context,
    fetcherName: 'fetchCartFee',
  })
}

export const fetchRetailerFees = (context: QueryFunctionContext) => {
  return apiGet<RetailerFeesResponse>({
    config: { url: 'fees/v1/retailers' },
    context,
    fetcherName: 'fetchRetailerFees',
  })
}

export const fetchNycOrdinanceFee = (context: QueryFunctionContext<NycOrdinanceFeeQueryKey>) => {
  const [, { storeZips, customerZip }] = context.queryKey
  return apiPost<NycOrdinanceFeeResponse>({
    config: {
      url: '/member-web-bff/v1/fees/nyc-ordinance-fee',
      data: {
        store_zips: storeZips,
        customer_zip: customerZip,
      },
    },
    context,
    fetcherName: 'fetchNycOrdinanceFee',
  })
}
